import {Button, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

import css from "../css/page404.module.css";

export const Page404 = () => {
    const navigate = useNavigate();
    return (
        <div className={css.container}>
            <Typography variant={"h3"}>Страница не найдена</Typography>
            <div className={css.action}>
                <Button variant={"contained"} onClick={()=>navigate("/app")}>Перейти к задачам</Button>
            </div>
        </div>
    )
}
